





































































































































import {Component, Vue} from "vue-property-decorator";
import breadcrumb from "@/components/common/breadcrumb.vue";
import upload from "@/components/upload/src/index.vue";
import {AmPageDetail, AmPageStatus, ConfigType} from "@/model/AmPage";
import store from "@/store";
import {getConfig, getPageDetail, updatePageDetail} from '@/services/api'
import {Message} from "element-ui";

enum SCENE {
  DETAIL,
  EDIT
}

@Component({
  components: {
    'zf-breadcrumb': breadcrumb,
    'zf-upload': upload,
  }
})
export default class PageDetail extends Vue{
  //面包屑导航
  public navList: {name: String, to?: String}[] = [
    {name: '粉丝页管理', to: '/page/list'}
  ];
  public SCENE = SCENE;
  public newPageId = '';
  public formData: AmPageDetail = {};
  // 状态列表
  public pageStatusList: {desc: string, code: number}[] = [];
  public publishStatusList: {desc: string, code: number}[] = [];
  public appealStatusList: {desc: string, code: number}[] = [];
  public pageOwnerList: {desc: string, code: number}[] = [];
  public pageLanguageList: {desc: string, code: number}[] = [];
  public pageStatusMap: {[prop: string]: string} = {};
  public publishStatusMap: {[prop: string]: string} = {};
  public appealStatusMap: {[prop: string]: string} = {};
  public pageOwnerMap: {[prop: string]: string} = {};
  public PageLanguageMap: {[prop: string]: string} = {};
  public decorationList: {desc: string, code: number}[] = [
    {desc: '是', code: 1},
    {desc: '否', code: 0}
  ];
  public decorationMap: {[prop: string]: string} = {
    '1': '是',
    '0': '否'
  };

  /**
   * watch
   * 当前的页面情景
   **/
  get scene(): SCENE|undefined {
    if(/^\/page\/detail/.test(this.$route.path)) {
      return SCENE.DETAIL;
    }
    if(/^\/page\/edit/.test(this.$route.path)) {
      return SCENE.EDIT;
    }
  }

  async created() {
    const pageId = this.$route.params.pageId;
    if(this.scene === SCENE.DETAIL) {
      let name = '粉丝页详情';
      this.navList.push({name});
      await this.getPageDetail(pageId);
      this.getConfig('pageStatusList', ConfigType.PageStatus, 'SET_PAGE_STATUS_LIST', 'pageStatusMap');
      this.getConfig('publishStatusList', ConfigType.PublishStatus, 'SET_PUBLISH_STATUS_LIST', 'publishStatusMap');
      this.getConfig('appealStatusList', ConfigType.AppealStatus,'SET_APPEAL_STATUS_LIST', 'appealStatusMap');
      this.getConfig('pageOwnerList', ConfigType.PageOwner,'SET_PAGE_OWNER_LIST', 'PageOwnerMap');
      this.getConfig('pageLanguageList', ConfigType.PageLanguage,'SET_PAGE_LANGUAGE_LIST', 'pageLanguageMap');
    } else if (this.scene === SCENE.EDIT) {
      let name = '粉丝页修改';
      this.navList.push({name});
      await this.getPageDetail(pageId);
      this.getConfig('pageLanguageList', ConfigType.PageLanguage,'SET_PAGE_LANGUAGE_LIST', 'pageLanguageMap');
      this.getConfig('publishStatusList', ConfigType.PublishStatus, 'SET_PUBLISH_STATUS_LIST', 'publishStatusMap');
    }
  }

  /**
   * 获取粉丝页
   */
  getPageDetail(pageId: string) {
    getPageDetail({pageId}).then(res => {
      if (res.data && res.data.code === 200) {
        this.formData = res.data.data || {};
      } else {
        Message.error(res.data.message)
      }
    })
  }

  /**
   * 获取字典信息
   */
  getConfig(listName: string, type: ConfigType, method: string, listMapName: string): void {
    const listMap: { [prop: string]: string } = {};
    if (!this.$store.state[listName] || this.$store.state[listName]?.length === 0) {
      getConfig({type}).then(res => {
        if (res.data && res.data.code === 200) {
          this.$set(this, listName, res.data.data || [])
          store.commit(method, res.data.data || []);
          if (this.$store.state[listName] && this.$store.state[listName].length > 0) {
            for (let item of this.$store.state[listName]) {
              listMap[item.code.toString()] = item.desc;
            }
            this.$set(this, listMapName, listMap)
          }
        }
      })
    } else {
      this.$set(this, listName, this.$store.state[listName])
      if (this.$store.state[listName] && this.$store.state[listName].length > 0) {
        for (let item of this.$store.state[listName]) {
          listMap[item.code.toString()] = item.desc;
        }
        this.$set(this, listMapName, listMap)
      }
    }
  }

  /**
   * 添加关联主页
   */
  addNewPage() {
    if (!this.formData.pages) {
      this.formData.pages = [];
    }
    if (!this.newPageId) {
      Message.warning('请输入pageid');
      return;
    }
    for (let item of this.formData.pages) {
      if (item.pageId === this.newPageId) {
        if (item.delete) {
          item.delete = false;
        } else {
          Message.warning('该主页已存在');
        }
        return;
      }
    }
    this.formData.pages.push({pageId: this.newPageId})
    this.newPageId = '';
  }

  deleteNewPage(index: number, page: AmPageStatus) {
    if (page.pageStatus === undefined) {
      this.formData.pages?.splice(index, 1);
    } else {
      page.delete = true;
    }
  }

  /**
   * 详情跳转修改
   */
  routerTo(path:'edit'|'detail') {
    this.$router.push(`/page/${path}/${this.$route.params.pageId}`)
  }

  /**
   * 提交
   */
  submit() {
    updatePageDetail(this.formData).then(res => {
      if (res.data && res.data.code === 200) {
        Message.success(res.data.message);
        this.routerTo('detail');
      } else {
        Message.error(res.data.message);
      }
    })
  }

  /**
   * 打开新的窗口
   */
  openWindow(url: string): void {
    window.open(url,'_blank')
  }
}
